<template>
  <!-- 新建/编辑 -->
    <el-drawer
        :title="control.title"
        :enums="enums"
        :with-header="false"
        :visible.sync="control.show"
        direction="rtl"
        size="70%">
        <!-- <el-divider>创建</el-divider> -->
        <el-form status-icon :model="form" :rules="rules" ref="form" label-width="100px">
          <el-row>
            <el-col :span="12">
              <el-form-item prop="organizationName" label="公司名称" :label-width="formLabelWidth">
                <div>公司名称：{{form.organizationName}}</div>
                <div>店铺名称：{{form.storeName}}</div>
                <div>入驻时间：{{form.checkinTime}}</div>
                <div>剩余服务币：<span style="color: red;">{{form.score + ' '}}</span>服务币</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item prop="amount" label="充值金额" :label-width="formLabelWidth">
                <el-input type="number" v-model="form.amount" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label-width="5px">
                服务币
              </el-form-item>
            </el-col>
          </el-row>


          <el-form-item :label-width="formLabelWidth">
            <el-button v-if="!control.disabled" type="primary" @click="handleSubmit(control.action)" size="mini">提交</el-button>
          </el-form-item>
        </el-form>
    </el-drawer>
</template>

<script>
import  * as AliossApi from '@/api/alioss'
import * as EnumApi from '@/api/enums'
const OSS = require('ali-oss');
import Quill from 'quill'
import * as OrganizationApi from '@/api/organization'

export default {
  name: 'OrganizationForm',
  props: {
    enums: '',
    categories: [],
    parents: '',
    control: Object
  },
  data() {
    var checkNumber = (rule, value, callback) => {
        if (!value && value!=0) {
          return callback(new Error('排序值不能为空'));
        }
        callback();
      };
    return {
      checkList: [],
      editorOption: {
        placeholder: '请填写简介',
        modules:{
　　　　　　toolbar: [
              // [{ 'size': ['small' ,'large', 'huge'] }],
              ['bold', 'italic', 'underline'],
              ['blockquote'],
              [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
              // [{ 'font': [] }],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              ['link', 'image']
            ],
        },
        // theme:'snow'
      },
      formLabelWidth: '80px',
      form: {orderNumber: 0},
      rules: {
        name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    editor() {
        return this.$refs.myQuillEditor.quill;
    },
    categoriesClone() {
        return Object.assign({}, this.categories);
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init(){
      let that = this;
      console.log("init action >> " + that.control.action, that.control)
      this.categories.forEach((item, index) => {
        item.checked = false
      })
      if(that.$permits.CREATE === that.control.action){
        that.form = Object.assign({}, {});
        return
      }

      that.form = Object.assign({}, that.control.form);
      this.categories.forEach((item, index) => {
        if(this.form.storeDishes){
          item.checked = this.form.storeDishes.split(',').includes(item.id)
        }
      })
      // this.addImageHandler();
    },
    handleCheckedCategoriesChange(value) {
      console.log("handleCheckedCategoriesChange >> ", value, this.checkList, this.form.storeDishes)
      this.form.storeDishes = this.checkList.join(',')
    }
,
    addImageHandler(){
      this.$refs.myQuillEditor.quill.getModule("toolbar").addHandler("image", this.updatePicture)
    },
    async handleSubmit(action) {
      let that = this;
      that.$refs['form'].validate((valid) => {
        console.log("validate >> starting...")
        if(valid){
          switch(action){
            case that.$permits.UPDATE:
              OrganizationApi.voucher({id: that.form.id, amount: that.form.amount}).then(res => {
                that.control.show = false;
                that.$parent.handlePage();
              })
              console.log("switch >>> " + that.$permits.UPDATE)
              break;
            case that.$permits.CREATE:
              OrganizationApi.create(that.form).then(res => {
                that.control.show = false;
                that.$parent.handlePage();
              })
              console.log("switch >>> " + that.$permits.CREATE)
              break;
          }
        }
        console.log("validate >> stop, valid: " + valid)
      });
    },
    updatePicture() {
      this.flag = 'logo';
      this.$el.querySelector('.'+this.flag).click()
    },
    async handleFile(e) {
      var vm = this;
      console.log('e', e)
      const $target = e.target || e.srcElement
      var file = $target.files[0]

      let fileType = file.type.toLowerCase()
      let ext
      if(fileType.indexOf('image') >= 0){
        ext = '.jpeg';
      }

      let storeAs = process.env.VUE_APP_CURRENTMODE + '/' + Number(new Date().getTime()/(3600*24*7*1000)).toFixed(0) + '/' + this.guid().replace(/-/g,'') + ext
      console.log(storeAs);

      // OSS.urlib是sdk内部封装的发送请求的逻辑，开发者完全可以使用任何发请求的库向`sts-server`发送请求
      let res = await AliossApi.ststoken()
      const result = res.data.data
      const client = new OSS({
        accessKeyId: result.accessKeyId,
        accessKeySecret: result.accessKeySecret,
        stsToken: result.stsToken,
        endpoint: result.endpoint,
        bucket: result.bucket
      })
      client.put(storeAs, file).then(result => {
        let picUrl = result.res.requestUrls[0];
        console.log('picUrl', picUrl);
        this.form.picUrl = picUrl.split("?")[0];
        console.log('this.form.picUrl', this.form.picUrl);
        let url = this.form.picUrl;
        if (url != null && url.length > 0) {
          var value = url
          vm.addImgRange = vm.$refs.myQuillEditor.quill.getSelection()
          console.log('vm.addImgRange', vm.addImgRange);
          value = value.indexOf('http') != -1 ? value : 'http:' + value
          console.log('value', value);
          vm.$refs.myQuillEditor.quill.insertEmbed(vm.addImgRange != null?vm.addImgRange.index:0, 'image', value, Quill.sources.USER)
          console.log('content', this.form.content);
        } else {
          vm.$message.warning("图片增加失败")
        }
      }).catch(function(err) {})
    },
    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(
        c) {
        var r = (Math.random() * 16) | 0
        var v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    },
    onEditorReady(editor) { // 准备编辑器
    },
    onEditorBlur(){}, // 失去焦点事件
    onEditorFocus(){}, // 获得焦点事件
    onEditorChange(){
      console.log(this.form);
    }, // 内容改变事件
  }
}
</script>

<style>
</style>
